import type { TranslationDictionary } from "./types";

export const ES_DICTIONARY: TranslationDictionary = {
    "app.newTask": "Nuevo",
    "app.newTaskAria": "Nuevo chat",
    "sidebar.searchPlaceholder": "Mensajes de búsqueda o tarea ID",
    "sidebar.filters": "Filtros de tareas",
    "sidebar.allRatios": "Todas las proporciones",
    "sidebar.allOrientations": "Todas las orientaciones",
    "sidebar.allModes": "Todos los modos",
    "sidebar.allResolutions": "Todas las resoluciones",
    "sidebar.activeTasks": "Tareas activas",
    "sidebar.topAnchors": "Navegación en el mejor momento",
    "sidebar.bottomAnchors": "Navegación en el tiempo inferior",
    "sidebar.resize": "Cambiar el tamaño de la barra lateral",
    "batch.selected": "0 seleccionado",
    "batch.selectedCount": "{count} seleccionado",
    "batch.archivedCount": "Chats {count} archivados",
    "batch.archiveFailed": "Error al archivar por lotes",
    "batch.runningCannotDeleteSelected": "Los chats seleccionados se están ejecutando y no se pueden eliminar",
    "batch.deleteTitle": "¿Eliminar chats {count}?",
    "batch.deleteMessage": "Esto también eliminará los archivos de imágenes locales.",
    "batch.deleteSkippedDetail": "{count} se mantendrán las tareas en ejecución",
    "batch.deleteSkippedSuffix": ", {count} tareas en ejecución no eliminadas",
    "batch.deletedCount": "Eliminados {count} chats{skipped}",
    "batch.deleteFailed": "Error al eliminar el lote",
    "action.archive": "Archivo",
    "action.delete": "Eliminar",
    "action.cancel": "Cancelar",
    "action.edit": "Editar",
    "action.clear": "Borrar",
    "action.paste": "Pegar",
    "action.find": "encontrar",
    "action.replace": "Reemplazar",
    "action.close": "Cerrar",
    "action.confirm": "Confirmar",
    "action.confirmQuestion": "¿Confirmar acción?",
    "action.refresh": "Actualizar",
    "action.save": "Guardar",
    "action.add": "Añadir",
    "action.new": "Nuevo",
    "action.import": "Importar",
    "action.export": "Exportar",
    "queue.empty": "Sin cola",
    "queue.emptyAria": "Estado de la cola: sin tareas en cola",
    "queue.jumpTitle": "Saltar a tareas activas",
    "queue.emptyTitle": "Sin tareas en cola",
    "queue.channel": "Canales {count}",
    "queue.availableChannels": "Canales disponibles {usable}/{total}",
    "queue.dispatching": "Programación · esperando {waiting}",
    "queue.runningWaiting": "Ejecutando {running} · esperando {waiting}",
    "queue.statusLabel": "Estado de la cola: {text} · {channelText}. Haga clic para saltar a las tareas activas",
    "queue.runningActions": "Ejecutar acciones de la cola de tareas",
    "queue.waitingActions": "Esperando acciones de la cola de tareas",
    "queue.cancelRunning": "Cancelar",
    "queue.cancelRunningTitle": "Cancelar tarea en ejecución",
    "queue.dragWaiting": "Arrastre para reordenar la tarea en espera",
    "queue.dragSort": "Arrastra para ordenar",
    "queue.moveUp": "arriba",
    "queue.moveUpTitle": "Mover la tarea en espera hacia arriba",
    "queue.moveDown": "abajo",
    "queue.moveDownTitle": "Mover la tarea en espera hacia abajo",
    "queue.promote": "arriba",
    "queue.promoteTitle": "Mover la tarea en espera al principio",
    "queue.promoteFailed": "Error al subir al principio",
    "queue.deleteWaitingShort": "Del",
    "queue.deleteWaitingTitle": "Eliminar tarea en espera",
    "queue.deleteWaitingTitleConfirm": "¿Eliminar tarea en espera?",
    "queue.deleteWaitingMessage": "Esto lo elimina de la cola y de la lista del historial.",
    "queue.deleteQueuedFailed": "No se pudo eliminar la tarea en cola",
    "queue.queuedDeleted": "Tarea en cola eliminada",
    "queue.cancelRunningConfirm": "Cancelar tarea",
    "queue.cancelRunningTitleConfirm": "¿Cancelar tarea en ejecución?",
    "queue.cancelRunningMessage": "La tarea actual se detendrá. La historia se mantendrá.",
    "queue.cancelRunningFailed": "No se pudo cancelar la tarea",
    "queue.runningCancelled": "Tarea cancelada",
    "queue.reorderFailed": "No se pudo reordenar la cola",
    "queue.realtimeUpdateFailed": "No se pudo actualizar el estado en vivo",
    "queue.realtimeDisconnected": "Se perdió la conexión del estado en vivo. Actualiza la página para recuperarla.",
    "queue.readFailed": "No se pudo cargar la cola",
    "status.waiting": "esperando",
    "status.shownActiveTasks": "Mostrando tareas activas",
    "status.jsonCopied": "JSON copiado",
    "taskStatus.submitting": "Presentando",
    "taskStatus.running": "generando",
    "taskStatus.runningWithElapsed": "Generando · {elapsed}",
    "taskStatus.completed": "Completado",
    "taskStatus.partialFailed": "Parcialmente fallido",
    "taskStatus.failed": "Fallido",
    "taskStatus.queued": "En cola",
    "taskStatus.unknown": "Estado desconocido",
    "taskStatus.task": "Tarea",
    "taskStatus.connectionInterrupted": "Conexión interrumpida",
    "taskStatus.lastFailed": "Último error",
    "taskStatus.waitingRetry": "{reason}, esperando volver a intentarlo (intento {attempt}/{max})",
    "taskStatus.retrying": "{reason}, reintentando (intento {attempt}/{max})",
    "taskStatus.nonRetryableAttempt": "Intento {attempt}/{max}, no reintentable",
    "taskStatus.manualRetryAvailable": "Detenido; las imágenes fallidas se pueden volver a intentar manualmente",
    "taskStatus.waitingRetryShort": "Esperando reintento",
    "taskStatus.retryingShort": "Reintentando",
    "taskStatus.nonRetryableShort": "No reintentable",
    "taskStatus.manualRetryShort": "Reintento manual",
    "taskStatus.stoppedShort": "Detenido",
    "taskStatus.runtime": "Duración {duration}",
    "taskStatus.runtimeCompleted": "Duración {duration} · completado {time}",
    "taskStatus.completedAt": "Completado {time}",
    "taskCard.count": "{count} imágenes",
    "taskCard.successCount": "tuvo éxito {count}",
    "taskCard.failedCount": "falló {count}",
    "taskCard.runningCount": "generando {count}",
    "taskCard.waitingCount": "esperando {count}",
    "taskCard.textToImageThumb": "Miniatura de tarea de conversión de texto a imagen",
    "taskCard.imageToImageThumb": "Miniatura de tarea de imagen a imagen",
    "taskCard.failedThumb": "Tarea fallida",
    "taskCard.textBadge": "t",
    "taskMode.edit": "Editar",
    "taskMode.generate": "generar",
    "document.generatingQueue": "Generando · cola {total}",
    "document.queuedWaiting": "En cola · esperando {count}",
    "runFeedback.editing": "Edición",
    "runFeedback.generating": "generando",
    "runFeedback.status": "{action}, transcurrido {elapsed}",
    "footer.archive": "Archivo",
    "footer.archiveCount": "Archivo {count}",
    "footer.historyLibrary": "Historia",
    "historyLibrary.openFull": "Abrir biblioteca de historia completa",
    "history.documentTitle": "Historia - 阿泰生图",
    "history.back": "Volver al generador",
    "history.title": "Historia",
    "history.loading": "Cargando",
    "history.total": "{total} tareas · {archived} archivado",
    "history.search": "Buscar",
    "history.searchPlaceholder": "Mensajes de búsqueda o tarea ID",
    "history.clear": "Borrar",
    "history.type": "Tipo",
    "history.allTypes": "Todos los tipos",
    "history.type.textToImage": "Texto a imagen",
    "history.type.imageToImage": "Imagen a imagen",
    "history.month": "Mes",
    "history.status": "Estado",
    "history.promptMode": "Tratamiento del prompt",
    "history.size": "Tamaño",
    "history.quality": "Calidad",
    "history.ratio": "proporción",
    "history.orientation": "Orientación",
    "history.backend": "backend",
    "history.provider": "Proveedor",
    "history.archived": "Archivado",
    "history.all": "Todos",
    "history.allMonths": "Todos los meses",
    "history.allStatuses": "Todos los estados",
    "history.allPromptModes": "Todos los modos",
    "history.allSizes": "Todos los tamaños",
    "history.allQualities": "Todas las calidades",
    "history.allRatios": "Todas las proporciones",
    "history.ratioOther": "Otro",
    "history.allOrientations": "Todas las orientaciones",
    "history.allBackends": "Todos los servidores",
    "history.allProviders": "Todos los proveedores",
    "history.unarchived": "Sin archivar",
    "history.archivedOnly": "Archivado",
    "history.tasksAria": "Tareas históricas",
    "history.taskListTitle": "Tareas históricas",
    "history.browseNewest": "Explorar primero lo más nuevo",
    "history.view": "Ver",
    "history.grid": "Cuadrícula",
    "history.list": "Lista",
    "history.sort": "ordenar",
    "history.newest": "Lo más nuevo primero",
    "history.oldest": "El más viejo primero",
    "history.refresh": "Actualizar",
    "history.selectedCount": "{count} tareas seleccionadas",
    "history.confirmDelete": "Confirmar eliminación",
    "history.detail": "Detalle de la tarea",
    "history.detailTitle": "Tarea de historia",
    "history.closeDetail": "Cerrar detalle de tarea",
    "history.resizeFilters": "Cambiar el tamaño de la barra lateral del filtro",
    "history.resizeDetail": "Cambiar el tamaño del panel de detalles",
    "history.detailEmpty": "Seleccione una tarea histórica para ver los detalles",
    "history.loadingDetail": "Cargando detalle...",
    "history.loadMore": "Cargar más",
    "history.loadingMore": "Cargando...",
    "history.noMore": "No más tareas",
    "history.loadFailed": "La carga falló. Actualiza o sigue desplazándote para volver a intentarlo",
    "history.summaryFailed": "No se pudo cargar el resumen",
    "history.tasksFailed": "No se pudieron cargar las tareas",
    "history.detailFailed": "No se pudo cargar el detalle",
    "history.noMatches": "No hay tareas coincidentes",
    "history.loadedCount": "{count} cargado",
    "history.windowNotice": "La lista montada está limitada a tareas {count}; desplácese hacia arriba o hacia abajo para restaurar tareas adyacentes a pedido.",
    "history.selectTask": "Seleccionar tarea",
    "history.viewing": "Visualización",
    "history.noPreview": "Sin imágenes de vista previa",
    "history.downloadAll": "Descargar ZIP",
    "history.downloadImage": "Descargar imagen",
    "history.downloadSelected": "Descargar seleccionado",
    "history.deleteUnselected": "Eliminar no seleccionados",
    "history.confirmDeleteUnselected": "Confirmar eliminación no seleccionada",
    "history.selected": "Seleccionado",
    "history.select": "Seleccionar",
    "history.downloadIndex": "Descargar {index}",
    "history.addReference": "Agregar referencia",
    "history.outputActions": "Acciones de imagen de resultado",
    "history.inputReferences": "Referencias de entrada",
    "history.inputReferenceIndex": "Referencia de entrada {index}",
    "history.copyPrompt": "Copiar mensaje",
    "history.copyPrompts": "Copiar indicaciones",
    "history.copyPromptShort": "Copiar",
    "history.copyPromptPanel": "Copiar {title}",
    "history.copyOutputPromptPanel": "Copiar imagen {index} mensaje revisado",
    "history.copyTaskIds": "Copiar tarea IDs",
    "history.reuseTask": "Ver en generador",
    "history.downloadTask": "Descargar",
    "history.downloadSelectedTasks": "Descarga por lotes",
    "history.contextMenuLabel": "Menú contextual de tareas de historial",
    "history.promptCopied": "Mensaje copiado",
    "history.promptsCopied": "Mensajes copiados de tareas {count}",
    "history.taskIdsCopied": "Copiado {count} tarea IDs",
    "history.promptCopiedShort": "Copiado",
    "history.promptCopyFailed": "No se pudo copiar el mensaje",
    "history.promptCopyFailedShort": "Fallido",
    "history.noPrompt": "Esta tarea no tiene ningún mensaje para copiar",
    "history.noPromptShort": "vacio",
    "history.downloadStarted": "Descarga iniciada",
    "history.batchDownloadStarted": "Descargas iniciadas para tareas {count}",
    "history.noDownloadableOutputs": "No hay imágenes descargables",
    "history.confirmDeleteSelected": "Confirmar eliminación seleccionada",
    "history.openPreview": "Abrir vista previa",
    "history.closePreview": "Cerrar vista previa",
    "history.untitled": "Sin título",
    "history.promptCompare": "Comparación rápida",
    "history.promptOriginal": "Aviso original",
    "history.promptSubmitted": "Mensaje optimizado",
    "history.promptRevised": "Resultado revisado",
    "history.outputRevisedPromptTitle": "Imagen {index} mensaje revisado",
    "history.outputRevisedPromptNotice": "Cada imagen tiene su propio mensaje revisado debajo de la imagen.",
    "history.promptEmpty": "Sin contenido",
    "history.promptMode.strict": "Fiel",
    "history.promptMode.original": "Original",
    "history.promptMode.off": "Automático",
    "history.quality.high": "Alto",
    "history.quality.medium": "Medio",
    "history.quality.low": "Bajo",
    "history.quality.auto": "Automático",
    "footer.batch": "lote",
    "footer.storage": "Almacenamiento",
    "footer.apiStatus": "Estado API: OK",
    "footer.version": "Versión {version}",
    "footer.versionInfo": "Información de versión",
    "footer.versionLoading": "Versión...",
    "footer.updateBadge": "Nueva versión disponible",
    "footer.updateAvailable": "Nueva versión {version}",
    "version.title": "Versión y actualización",
    "version.loading": "Estado de la versión de lectura",
    "version.current": "Versión actual",
    "version.latest": "Última versión",
    "version.source": "Tiempo de ejecución",
    "version.sourcePortable": "Paquete portátil",
    "version.sourceStandard": "Standard app",
    "version.sourceSource": "Pago de fuente",
    "version.upToDate": "Ya estás en la última versión.",
    "version.updateAvailable": "La versión {version} está disponible. Cierre la ventana del servidor WebUI y luego ejecute el actualizador para actualizar.",
    "version.standardUpdateAvailable": "Version {version} is available. Updater-enabled macOS standard apps can install it from Check for Updates in the menu bar; this link remains the manual fallback.",
    "version.standardManualInstall": "Updater-enabled macOS standard apps support user-confirmed replacement; older macOS apps and Windows standard ZIP packages still update manually.",
    "version.noUpdater": "Este tiempo de ejecución no es un paquete portátil, por lo que el actualizador no se puede iniciar automáticamente.",
    "version.openUpdater": "Iniciar actualizador",
    "version.release": "Ver comunicado",
    "version.updaterStarted": "Se inició el actualizador. Cierre la ventana actual del servidor WebUI y luego siga las indicaciones del actualizador.",
    "version.updaterFailed": "No se pudo iniciar el actualizador. Ejecute manualmente el script de actualización del paquete.",
    "version.historyTitle": "Novedades",
    "version.historyEmpty": "No hay notas de versión disponibles",
    "version.currentBadge": "Actual",
    "version.releaseDate": "{date}",
    "version.change.quick_gallery_picker": "Added a quick gallery modal picker with real-time search, multi-selection, and thumbnail optimizations.",
    "version.change.official_asset_library": "Se amplió la biblioteca oficial de logotipos, lemas y firmas comerciales con más marcas, líneas de negocio, formatos horizontales y verticales y variantes invertidas.",
    "version.change.material_picker_modal": "El selector de material ahora es un cuadro de diálogo con miniaturas grandes, categorías, búsqueda y selección múltiple.",
    "version.change.brand_name": "Se cambió el nombre del producto a AI Innovation Studio en todos los idiomas.",
    "version.change.brand_templates": "Se añadieron plantillas de marca seleccionables y composición automática de logotipos, lemas y otros elementos.",
    "version.change.brand_preview": "Los resultados de marca son coherentes en vista previa, historial, ampliación y descarga, conservando el cambio a la imagen original.",
    "version.change.mobile_workspace": "Se compactaron la cabecera móvil, la barra de acciones, el resumen de materiales y la vista previa vacía.",
    "version.change.task_center": "Se compactó el centro de tareas móvil y se añadió un indicador para tareas activas y en espera.",
    "version.change.brand_launch": "Se lanzó la experiencia móvil de marca con los recursos visuales de Hengtai.",
    "version.change.core_workflow": "Se incorporó el flujo básico de generación, cola, historial, galería y ajustes.",
    "notifications.title": "Notificaciones",
    "notifications.unread": "Notificaciones, {count} no leídas",
    "notifications.unreadSummary": "{count} no leído",
    "notifications.empty": "Sin notificaciones de tareas",
    "notifications.taskFailed": "Tarea fallida",
    "notifications.taskPartial": "Tarea parcialmente completada",
    "notifications.taskCompleted": "Tarea completada",
    "notifications.generationFailed": "Generación fallida",
    "notifications.successCount": "{count} tuvo éxito",
    "notifications.resultAvailable": "Resultados disponibles",
    "notifications.failedCount": "{count} falló",
    "notifications.systemUnsupported": "Este navegador no admite notificaciones del sistema.",
    "notifications.systemBlocked": "Las notificaciones del sistema están bloqueadas por el navegador. Habilítelos en la configuración del navegador.",
    "notifications.systemDenied": "Las notificaciones del sistema no están habilitadas",
    "notifications.systemEnabled": "Notificaciones del sistema habilitadas",
    "notifications.taskMissing": "La tarea no existe o fue eliminada",
    "theme.label": "Tema",
    "theme.system": "Automático",
    "theme.light": "Claro",
    "theme.dark": "Oscuro",
    "language.label": "Idioma de la interfaz",
    "language.zh": "中",
    "language.zhCN": "简体中文",
    "language.zhTW": "正體中文",
    "language.zhHK": "繁体中文",
    "language.ja": "日本語",
    "language.ko": "한국어",
    "language.en": "English",
    "language.es": "Español",
    "language.pt": "Português",
    "language.fr": "Français",
    "language.de": "Deutsch",
    "language.ru": "Русский",
    "language.it": "Italiano",
    "language.hi": "हिन्दी",
    "auth.label": "Fuente de autenticación",
    "auth.checking": "Comprobando autenticación",
    "auth.missingCodexSession": "No se detectó ninguna sesión Codex",
    "auth.switchFailed": "No se pudo cambiar la fuente de autenticación",
    "auth.sourceUnavailable": "{source} no disponible",
    "auth.notActive": "No activo",
    "api.settings": "Configuración del sistema",
    "api.provider": "API proveedor",
    "imageInput.title": "Imágenes",
    "imageInput.uploadAria": "Haz clic, suelta o pega imágenes y archivos",
    "imageInput.uploadFull": "Haz clic, suelta o pega imágenes y archivos",
    "imageInput.uploadCompact": "Añadir entrada",
    "imageInput.uploadSubtitle": "Admite imágenes y archivos de referencia de Responses",
    "imageInput.recent": "Cargas recientes",
    "imageInput.recentBadge": "Reciente",
    "imageInput.uploadBadge": "Subir",
    "imageInput.addToGallery": "Añadir a la galería",
    "imageInput.addToGalleryShort": "Galería",
    "imageInput.removeImage": "Quitar imagen",
    "imageInput.editedBadge": "Editado",
    "imageInput.editImage": "Editar {name}",
    "imageInput.deletedRecent": "Carga reciente eliminada",
    "imageInput.deletedGallery": "Imagen de la galería eliminada",
    "recentAssets.defaultName": "Carga reciente",
    "recentAssets.use": "Utilice {name}",
    "recentAssets.delete": "Eliminar {name}",
    "recentAssets.deleteTitle": "¿Eliminar carga reciente?",
    "recentAssets.deleteMessage": "Esto eliminará la imagen de Cargas recientes. Si actualmente está seleccionado como entrada de imagen, se eliminará de la entrada actual. Las tareas históricas que hacen referencia a esta carga reciente perderán esa vista previa de entrada. La galería pública no se ve afectada.",
    "recentAssets.loadFailed": "No se pudieron cargar las cargas recientes",
    "recentAssets.deleteFailed": "No se pudo eliminar la carga reciente",
    "recentAssets.deleted": "Carga reciente eliminada",
    "inputSource.uploadFallback": "Imagen cargada",
    "inputSource.galleryFallback": "Imagen de la galería",
    "inputSource.focusPasteFallback": "{prefix}. La entrada de imágenes está enfocada; presione {shortcut} para pegar imágenes.",
    "inputSource.pastedCount": "Imágenes pegadas del portapapeles {count}",
    "inputSource.droppedCount": "Se agregaron imágenes caídas {count}",
    "inputSource.dropImagesOnly": "Soltar archivos de imagen únicamente",
    "inputSource.clipboardUnsupported": "Este navegador no puede leer el portapapeles directamente",
    "inputSource.clipboardEmpty": "No se encontraron imágenes del portapapeles",
    "inputSource.clipboardDenied": "El navegador bloqueó el acceso directo al portapapeles",
    "inputSource.clipboardReadFailed": "No se pudo leer el portapapeles",
    "status.missingGalleryReference": "Se ha eliminado una imagen de referencia de la galería. Retírelo antes de generar.",
    "status.missingRecentReference": "Se ha eliminado una imagen de referencia cargada recientemente. Retírelo antes de generar.",
    "status.emptyPrompt": "Ingrese un mensaje",
    "status.editNeedsImage": "El modo de edición requiere al menos una imagen",
    "status.loadedTask": "Tarea cargada {taskId}",
    "status.reusedTask": "Tarea abierta {taskId} en generador",
    "status.loadingHistoryInputs": "Cargando imágenes de entrada históricas...",
    "status.historyInputLoadFailed": "No se pudo cargar la imagen de entrada histórica: {url}",
    "referenceCollector.alreadyStaged": "Ya puesto en escena como referencia.",
    "referenceCollector.staged": "Imágenes de referencia preparadas {count}",
    "referenceCollector.title": "Referencias pendientes · {count}",
    "referenceCollector.addAll": "Agregar todas las referencias",
    "referenceCollector.itemFallback": "Referencia pendiente",
    "referenceCollector.remove": "Eliminar referencia pendiente",
    "referenceCollector.cleared": "Referencias pendientes borradas",
    "referenceCollector.added": "Se agregaron imágenes de referencia {count}",
    "referenceCollector.addFailed": "No se pudieron agregar referencias pendientes",
    "referenceCollector.readFailed": "No se pudo leer la imagen: {status}",
    "gallery.quick": "galería rápida",
    "gallery.current": "Galería de categorías actuales",
    "gallery.categories": "Categorías de la galería",
    "gallery.categoryPortrait": "retrato",
    "gallery.categoryCharacter": "Personaje",
    "gallery.categoryProduct": "Producto",
    "gallery.categoryPortraitRole": "Referencia de retrato",
    "gallery.categoryCharacterRole": "Referencia de personaje",
    "gallery.categoryProductRole": "Referencia del producto",
    "gallery.referenceRole": "Imagen de referencia",
    "gallery.manage": "Administrar galería",
    "gallery.loadFailed": "No se pudo cargar la galería",
    "gallery.imageOrderUpdateFailed": "No se pudo actualizar el orden de las imágenes",
    "gallery.imageOrderUpdated": "Orden de imágenes actualizado",
    "gallery.categoryName": "Nombre de categoría",
    "gallery.categoryPromptRole": "papel rápido",
    "gallery.categorySave": "Guardar",
    "gallery.categoryDelete": "Eliminar",
    "gallery.categoryLoadFailed": "No se pudieron cargar las categorías",
    "gallery.categoryNameRequired": "Introduzca un nombre de categoría",
    "gallery.categoryCreateFailed": "No se pudo agregar la categoría",
    "gallery.categoryCreated": "Categoría agregada",
    "gallery.categorySaveFailed": "No se pudo guardar la categoría",
    "gallery.categorySaved": "Categoría guardada",
    "gallery.categoryDeleteTitle": "¿Eliminar categoría de galería?",
    "gallery.categoryDeleteMessage": "Las imágenes de esta categoría pasarán a otra categoría. Las imágenes de la galería no se eliminarán.",
    "gallery.categoryDeleteConfirm": "Eliminar categoría",
    "gallery.categoryDeleteFailed": "No se pudo eliminar la categoría",
    "gallery.categoryDeletedMigrated": "Categoría \"{name}\" eliminada y imágenes migradas",
    "gallery.categoryOrderUpdateFailed": "No se pudo actualizar el orden de las categorías",
    "gallery.categoryOrderUpdated": "Orden de categorías actualizado",
    "gallery.categoryFallback": "Categoría de galería",
    "gallery.imageFallback": "Imagen de la galería",
    "gallery.imageLoadFailed": "No se pudo cargar esta imagen",
    "gallery.editImageLoadFailed": "No se pudo cargar esta imagen para editarla",
    "gallery.cannotAddImage": "Esta imagen no se puede agregar a la galería.",
    "gallery.nameRequired": "Introduce un nombre de galería",
    "gallery.saveFailed": "No se pudo guardar la imagen de la galería",
    "gallery.savedAsReference": "Agregado a la galería y cambiado a referencia de la galería.",
    "gallery.renameImage": "Cambiar el nombre de la imagen de la galería",
    "gallery.moveToCategory": "Mover a categoría",
    "gallery.categoryRequired": "Elige una categoría de galería",
    "gallery.promptNoteTitle": "Nota de referencia de la galería",
    "gallery.updateFailed": "No se pudo actualizar la galería",
    "gallery.selectImageFile": "Elige un archivo de imagen",
    "gallery.replaceImageFailed": "No se pudo reemplazar la imagen de la galería",
    "gallery.replacedImage": "Se reemplazó la imagen de origen por \"{name}\"",
    "gallery.deleteImageTitle": "¿Eliminar imagen de la galería?",
    "gallery.deleteImageMessage": "Las referencias históricas de tareas se mostrarán como eliminadas.",
    "gallery.deleteFailed": "No se pudo eliminar la imagen de la galería",
    "gallery.deletedSuffix": "(eliminado)",
    "gallery.editImageLabel": "Editar imagen de la galería",
    "gallery.fieldCategory": "Categoría",
    "gallery.fieldPromptNote": "Nota de referencia",
    "gallery.fieldName": "Nombre",
    "quickGallery.empty": "No hay imágenes {category}",
    "promptGallery.remove": "Quitar @{name}",
    "prompt.title": "rápido",
    "prompt.editorLabel": "rápido",
    "prompt.placeholder": "Describe la imagen que deseas generar o editar. Escriba @ para referencias de galería, # para códigos de color y ~ para fragmentos de mensajes.",
    "prompt.run": "generar",
    "prompt.runEdit": "Empezar a editar",
    "prompt.runTitle": "Generar (Cmd+Enter)",
    "prompt.runEditTitle": "Iniciar edición (Cmd+Enter)",
    "prompt.findPanel": "Buscar y reemplazar mensaje",
    "prompt.findText": "Buscar texto",
    "prompt.replaceWith": "Reemplazar con",
    "prompt.findActions": "Buscar y reemplazar acciones",
    "prompt.countZero": "0 coincidencias",
    "prompt.matchCount": "{count} coincidencias",
    "prompt.foundCount": "Se encontraron coincidencias {count}",
    "prompt.noMatch": "No hay texto coincidente",
    "prompt.replacedCount": "Coincidencias {count} reemplazadas",
    "prompt.closeFind": "Cerrar buscar y reemplazar",
    "prompt.recentTemplates": "Plantillas recientes",
    "prompt.manageTemplates": "Administrar plantillas",
    "promptModel.galleryHeader": "Notas de la imagen de referencia:",
    "promptModel.galleryInstruction": "- Imagen de referencia {number}: galería \"{name}\", rol: {role}. @{name} en el mensaje se refiere a esta imagen.{note}",
    "outputSettings.title": "Salida",
    "output.lock.lock": "Bloquear parámetros",
    "output.lock.unlock": "Desbloquear y editar",
    "output.lock.current": "Bloqueo actual",
    "output.lock.task": "Parámetros de la tarea",
    "output.lock.adoptTask": "Usar parámetros de esta tarea",
    "output.lock.frame": "Encuadre",
    "output.lock.outputCount": "Cantidad de salidas",
    "output.lock.output": "Salida",
"output.lock.search": "Búsqueda",
    "output.lock.call": "Llamada",
    "output.lock.sheets": "imágenes",
    "output.lock.imageModel": "Modelo de imagen",
    "output.lock.prompt": "Prompt",
    "output.lock.fileFormat": "Formato de archivo",
    "output.lock.taskHint": "Solo se muestran los parámetros de la tarea; el bloqueo actual no cambia. Usarlos no cambia el canal del sistema.",
    "output.lock.lockedHint": "Los parámetros están fijados. Usa el candado superior para editar.",
    "output.lock.enabled": "Activada",
    "output.lock.disabled": "Desactivada",
    "output.mainModel": "modelo principal",
    "output.selectMainModel": "Seleccionar modelo principal",
    "output.mainModelCustomForInput": "Utilice un modelo personalizado para la entrada actual",
    "output.apiDirect": "API Directo",
    "output.apiToolModel": "Usando el modelo de generación de imágenes API",
    "output.mainModelUnused": "El modelo principal no se utiliza para esta solicitud.",
    "output.webSearch": "búsqueda web",
    "output.webSearchToggle": "encendido",
    "output.webSearchTitle": "Primero busque en la web y luego úsela para esta generación; Codex y API Responses únicamente",
    "output.promptMode": "Tratamiento del prompt",
    "output.modeOriginal": "Original",
    "output.modeStrict": "Fiel",
    "output.modeCreative": "Automático",
    "output.promptHelp": "Explicar el tratamiento del prompt",
    "output.promptHelpTitle": "Tratamiento del prompt",
    "output.promptHelp.responsesChannel": "Responses · interviene el modelo principal",
    "output.promptHelp.imagesChannel": "Images · generación directa",
    "output.promptHelp.responses.original": "Envía el texto original al modelo principal y pide conservarlo en la herramienta de imagen; aun así puede generar un revised prompt.",
    "output.promptHelp.responses.strict": "Permite ordenar o ampliar el prompt, pero conserva restricciones como sujetos, texto, colores y composición.",
    "output.promptHelp.responses.automatic": "No añade restricciones; el modelo principal interpreta y optimiza antes de llamar a la herramienta de imagen.",
    "output.promptHelp.images.original": "No añade reglas de la aplicación y envía el texto original directamente a la API de imágenes.",
    "output.promptHelp.images.strict": "Envía reglas de fidelidad junto al prompt original para preservar todas las restricciones.",
    "output.promptHelp.images.automatic": "Usa el tratamiento predeterminado de la API de imágenes e incluye las notas necesarias de referencias de la galería.",
    "output.sizeMode": "Modo de tamaño",
    "output.sizePreset": "Preestablecido",
    "output.sizeCustom": "personalizado",
    "output.orientation": "Orientación",
    "output.square": "cuadrado",
    "output.portrait": "retrato",
    "output.landscape": "paisaje",
    "output.resolution": "Resolución",
    "output.pixelSize": "Tamaño de píxel",
    "output.width": "Ancho",
    "output.height": "altura",
    "output.swapSize": "Intercambiar ancho y alto",
    "output.customSizeHint": "Unidad px · 16-3840 · múltiplo de 16 · ≤3:1",
    "output.imageSizeUnavailable": "Tamaño de imagen no disponible",
    "output.imageLoadFailed": "La imagen no pudo cargarse",
    "output.customSizeRequired": "Introduzca ancho y alto",
    "output.customSizeBounds": "El ancho y el alto deben ser de 16 a 3840 px.",
    "output.customSizeMultiple": "El ancho y el alto deben ser múltiplos de 16",
    "output.customSizeRatio": "La relación entre los lados largo y corto no puede exceder 3:1",
    "output.customSizePixels": "El total de píxeles debe ser de 655.360 a 8.294.400",
    "output.ratioLock": "Bloqueo de relación (opcional)",
    "output.customRatio": "Relación de aspecto personalizada",
    "output.ratioWidth": "W.",
    "output.ratioHeight": "h",
    "output.firstImageRatio": "Utilice la primera relación de aspecto de la imagen de referencia.",
    "output.useFirstImage": "De la imagen",
    "output.ratioHint": "Déjelo en blanco para tamaño libre · Complete ambos para sincronizar",
    "output.ratio": "proporción",
    "output.quality": "Calidad",
    "output.qualityAuto": "Automático",
    "output.qualityLow": "Bajo",
    "output.qualityMedium": "Medio",
    "output.qualityHigh": "Alto",
    "output.quantity": "contar",
    "output.pixelPreview": "Píxeles de salida: 1024 x 1024 px",
    "output.pixelPreviewValue": "Píxeles de salida: {value}",
    "output.pixelPreviewAuto": "Píxeles de salida: automático (OpenAI elige automáticamente)",
    "output.format": "Formato",
    "output.compression": "Compresión",
    "output.moderation": "Moderación",
    "preview.title": "Vista previa",
    "preview.selectedZero": "0 seleccionado",
    "preview.selectedCount": "Seleccionado {selected}/{total}",
    "preview.downloadSelected": "Descargar seleccionado",
    "preview.deleteUnselected": "Eliminar no seleccionados",
    "preview.downloadAll": "Descargar ZIP",
    "preview.empty": "Aún no hay imágenes",
    "preview.taskFailed": "Tarea fallida",
    "preview.partialFailed": "Algunas imágenes fallaron",
    "preview.failedOutput": "Imagen {index} fallida",
    "preview.progressLine": "Completado {generated} / {total} · transcurrido {elapsed}",
    "preview.failureLine": "Completado {generated} / {total} · fallido {failed}",
    "preview.elapsedLine": "Transcurrido {elapsed}",
    "preview.lastError": "Último error: {error}",
    "preview.continueGenerating": "Generación continua",
    "preview.waitingContinue": "esperando continuar",
    "preview.retryFailed": "Reintentar imágenes fallidas",
    "preview.acceptSuccesses": "Aceptar resultados exitosos",
    "preview.generateMode": "Generación",
    "preview.editMode": "Editar",
    "preview.runningTitle": "{mode} funcionando",
    "preview.submittingTitle": "Enviar tarea",
    "preview.queuedTitle": "Tarea en cola",
    "preview.submittingDetail": "Guardar entradas y agregar la tarea a la cola. La generación comenzará automáticamente.",
    "preview.queuedDetail": "La tarea está en cola y esperando un canal disponible.",
    "preview.featured": "Seleccionado",
    "preview.addFeatured": "Seleccionar resultado",
    "preview.selectedFeatured": "Seleccionado",
    "preview.removeFeatured": "Deseleccionar resultado",
    "preview.selectionAdded": "Resultado seleccionado",
    "preview.selectionRemoved": "Resultado no seleccionado",
    "preview.selectionUpdateFailed": "No se pudo actualizar la selección",
    "preview.noUnselectedOutputs": "No hay imágenes no seleccionadas para eliminar",
    "preview.deleteUnselectedTitle": "¿Eliminar imágenes no seleccionadas?",
    "preview.deleteUnselectedMessage": "Esto eliminará los archivos de imagen locales de los resultados no seleccionados en esta tarea.",
    "preview.deleteUnselectedDetail": "Mantener {selected}, eliminar {deleted}",
    "preview.deleteUnselectedFailed": "No se pudieron eliminar las imágenes no seleccionadas",
    "preview.deleteUnselectedDone": "Imágenes no seleccionadas eliminadas",
    "preview.addReference": "Agregar referencia",
    "preview.stage": "etapa",
    "preview.stageReference": "Etapa como referencia pendiente",
    "preview.prompt": "rápido",
    "preview.download": "Descargar",
    "preview.downloadImage": "Descarga esta imagen",
    "lightbox.label": "Vista previa de la imagen",
    "lightbox.close": "Cerrar vista previa",
    "lightbox.previous": "Imagen anterior",
    "lightbox.next": "Siguiente imagen",
    "promptPopover.title": "Comparación rápida",
    "promptPopover.summary": "Original {original} · optimizado {optimized}",
    "promptPopover.original": "Aviso original",
    "promptPopover.optimized": "Mensaje optimizado",
    "promptPopover.charCount": "{count} caracteres",
    "promptPopover.empty": "Ninguno",
    "promptPopover.notReturned": "No devuelto",
    "promptPopover.noOptimized": "No se devolvió ningún mensaje optimizado",
    "promptPopover.submitted": "Ver mensaje enviado",
    "promptPopover.close": "Cerrar comparación rápida",
    "promptPopover.copyOptimized": "Copiar mensaje optimizado",
    "promptPopover.copied": "Copiado",
    "taskContext.menuLabel": "Menú contextual de tareas",
    "taskContext.view": "Ver tarea",
    "taskContext.copyId": "Copiar tarea ID",
    "taskContext.copyPrompt": "Copiar mensaje",
    "taskContext.revealOutput": "Abrir carpeta de salida",
    "taskContext.archive": "Tarea de archivo",
    "taskContext.delete": "Eliminar tarea",
    "taskContext.idCopied": "Tarea ID copiada",
    "taskContext.promptCopied": "Mensaje copiado",
    "taskContext.noPrompt": "Esta tarea no tiene ningún mensaje para copiar",
    "taskContext.revealFailed": "No se pudo abrir la carpeta de salida",
    "taskContext.revealOpened": "Carpeta de salida abierta",
    "taskContext.actionFailed": "La acción de la tarea falló",
    "taskActions.group": "Acciones de tarea",
    "taskActions.deleteTitle": "¿Eliminar tarea?",
    "taskActions.deleteMessage": "Esto también eliminará los archivos de imágenes locales.",
    "taskActions.runningCannotDelete": "Las tareas en ejecución no se pueden eliminar",
    "taskActions.updated": "Estado de la tarea actualizado",
    "taskActions.archived": "Chat archivado",
    "taskActions.archiveFailed": "Error de archivado",
    "taskActions.deleted": "Tarea eliminada",
    "taskActions.deleteFailed": "Error al eliminar",
    "taskActions.noRetryableFailedImages": "Esta tarea no tiene imágenes fallidas para reintentar",
    "taskActions.retryFailedOutputsFailed": "No se pudieron reintentar las imágenes fallidas",
    "taskActions.requeuedFailedImages": "Imágenes fallidas puestas en cola",
    "taskActions.noAcceptableSuccessImages": "Esta tarea no tiene imágenes exitosas para aceptar.",
    "taskActions.acceptSuccessesFailed": "No se pudieron aceptar resultados exitosos",
    "taskActions.acceptedSuccesses": "Se aceptan resultados exitosos.",
    "taskActions.viewedUpdateFailed": "No se pudo actualizar el estado de lectura",
    "taskActions.failedFallback": "Tarea fallida",
    "taskList.empty": "Aún no hay historial",
    "taskList.selectSession": "Seleccionar chat",
    "taskList.unreadUpdate": "Actualización no leída",
    "taskList.viewing": "Visualización",
    "taskDerived.usageLimited": "Uso limitado",
    "taskSubmit.requestFailed": "Solicitud fallida",
    "taskSubmit.queued": "Tarea agregada a la cola",
    "taskSubmit.timeout": "Se agotó el tiempo de espera para enviar la tarea antes de que respondiera el backend. Actualice la cola para confirmar si se agregó y luego decida si desea volver a intentarlo.",
    "taskSubmit.failed": "Error al enviar la tarea",
    "templates.title": "Plantillas de mensajes",
    "templates.summary": "Biblioteca de plantillas locales",
    "templates.availableCount": "{count} plantillas disponibles",
    "templates.noMatch": "No hay plantillas coincidentes",
    "templates.empty": "Sin plantillas",
    "templates.favoriteBadge": "Favorito",
    "templates.usageCount": "{count} usos",
    "templates.back": "Atrás",
    "templates.edit": "Editar",
    "templates.copy": "Copiar",
    "templates.insert": "Insertar",
    "templates.formTitle": "Título",
    "templates.formShortTitle": "título corto",
    "templates.formCategory": "Categoría",
    "templates.formTags": "Etiquetas",
    "templates.formThumbnail": "Miniatura",
    "templates.formContent": "Contenido",
    "templates.formNotes": "Notas",
    "templates.formFavorite": "Favorito",
    "templates.thumbnailClear": "Borrar",
    "templates.thumbnailNone": "Ninguno seleccionado",
    "templates.thumbnailEmpty": "Sin miniaturas del historial",
    "templates.newCategory": "Nueva categoría",
    "templates.search": "Buscar plantillas, etiquetas o contenido",
    "templates.filter": "Filtros de plantilla",
    "templates.all": "Todos",
    "templates.categoryCommon": "común",
    "templates.categoryPortrait": "retrato",
    "templates.categoryProduct": "Producto",
    "templates.categoryRepair": "Reparación",
    "templates.categoryPoster": "Póster",
    "templates.categoryEcommerce": "Comercio electrónico",
    "templates.favorite": "Favoritos",
    "templates.recent": "Reciente",
    "templates.category": "Categorías",
    "templates.loadFailed": "No se pudieron cargar las plantillas de mensajes",
    "templates.useStateUpdateFailed": "No se pudo actualizar el estado de uso de la plantilla de aviso",
    "templates.copied": "Plantilla de aviso copiada",
    "templates.copyFailed": "No se pudo copiar la plantilla de solicitud",
    "templates.history": "Historia",
    "templates.saveFailed": "No se pudo guardar la plantilla de aviso",
    "templates.saved": "Plantilla de aviso guardada",
    "templates.deleteFailed": "No se pudo eliminar la plantilla de mensaje",
    "templates.deleted": "Plantilla de aviso eliminada",
    "templates.categoryAddFailed": "No se pudo agregar la categoría de plantilla",
    "templates.categoryAdded": "Categoría de plantilla agregada",
    "templates.categorySaveFailed": "No se pudo guardar la categoría de plantilla",
    "templates.categorySaved": "Categoría de plantilla guardada",
    "templates.categoryDeleteFailed": "No se pudo eliminar la categoría de plantilla",
    "templates.categoryDeleted": "Categoría de plantilla eliminada",
    "templates.importFailed": "No se pudo importar el paquete de plantillas",
    "templates.importedCount": "Plantillas {count} importadas",
    "templates.exportFailed": "No se pudo exportar el paquete de plantillas",
    "templates.exported": "Paquete de plantillas exportado",
    "snippets.suggestLabel": "Selector de fragmentos rápido",
    "snippets.saveSelection": "Guardar",
    "snippets.saveSelectionLabel": "Guardar el texto seleccionado como un fragmento de mensaje",
    "snippets.popoverLabel": "Fragmento rápido",
    "snippets.defaultCategory": "común",
    "snippets.loadFailed": "No se pudieron cargar fragmentos de mensajes",
    "snippets.remove": "Quitar ~{tag}",
    "snippets.expand": "Expandir",
    "snippets.edit": "Editar",
    "snippets.close": "Cerrar",
    "snippets.editTitle": "Editar fragmento",
    "snippets.saveTitle": "Guardar fragmento",
    "snippets.shortTag": "etiqueta corta",
    "snippets.title": "Título",
    "snippets.category": "Categoría",
    "snippets.content": "Contenido",
    "snippets.titlePlaceholder": "Utiliza etiqueta corta por defecto",
    "snippets.cancel": "Cancelar",
    "snippets.save": "Guardar",
    "snippets.saveFailed": "No se pudo guardar el fragmento de mensaje",
    "snippets.saved": "Fragmento de mensaje guardado",
    "snippets.defaultTag": "Fragmento común",
    "colors.white": "blanco",
    "colors.black": "negro",
    "colors.warmBeige": "Beige cálido",
    "colors.lightGreen": "Verde claro",
    "colors.brandGreen": "Marca verde",
    "colors.peachOrange": "Naranja melocotón",
    "colors.lightBlue": "azul claro",
    "colors.lightPink": "rosa claro",
    "colors.loadFailed": "No se pudo cargar la configuración de color",
    "colors.saveFailed": "No se pudo guardar la configuración de color",
    "colors.importFailed": "No se pudo importar la configuración de color",
    "colors.importedCount": "Colores {count} importados",
    "colors.recentSaveFailed": "No se pudieron guardar los colores recientes",
    "colors.favoriteSaveFailed": "No se pudo guardar el color favorito",
    "colors.favoriteDeleteFailed": "No se pudo eliminar el color favorito",
    "colors.update": "Actualizar",
    "colors.insert": "Insertar",
    "colors.pick": "Elige color",
    "colors.pickShort": "elegir",
    "colors.hexValue": "Valor de color",
    "colors.pendingUpdate": "El color cambió. Haga clic en Actualizar para aplicar.",
    "colors.save": "Guardar",
    "colors.exportPs": "Exportar",
    "colors.importPs": "Importar",
    "colors.done": "hecho",
    "colors.manage": "Administrar",
    "colors.favorites": "colores favoritos",
    "colors.recent": "Colores recientes",
    "colors.recentLabel": "Reciente",
    "colors.deleteFavorite": "Eliminar color favorito {name}",
    "colors.modify": "Editar color",
    "colors.modifyValue": "Editar color {value}",
    "colors.removeValue": "Quitar color {value}",
    "taskGroup.today": "hoy",
    "taskGroup.yesterday": "ayer",
    "taskGroup.last7": "últimos 7 días",
    "taskGroup.older": "mayor",
    "taskGroup.searchResults": "Resultados de la búsqueda",
    "taskGroup.active": "Activo",
    "taskGroup.running": "corriendo",
    "taskGroup.waiting": "esperando",
    "taskGroup.dispatchPending": "Asignando un canal disponible...",
    "taskGroup.expand": "Ampliar {label}",
    "taskGroup.collapse": "Contraer {label}",
    "taskGroup.buttonLabel": "Tareas {label}, {count}",
    "archive.title": "Archivo",
    "archive.empty": "No hay chats archivados",
    "archive.count": "{count} chats archivados",
    "archive.restore": "Restaurar",
    "archive.archiveFailed": "Error de archivado",
    "archive.restoreFailed": "Restauración fallida",
    "archive.restored": "Chat restaurado",
    "archive.archiving": "Archivando...",
    "archive.restoring": "Restaurando...",
    "archive.deleting": "Eliminando...",
    "archive.restoredCount": "Tareas {count} restauradas",
    "settings.title": "Almacenamiento",
    "settings.status": "Reinicie WebUI después de guardar las rutas de almacenamiento",
    "settings.inputRoot": "Carpeta de entrada",
    "settings.outputRoot": "Carpeta de salida",
    "settings.galleryRoot": "Carpeta de galería",
    "settings.sourceDataRoot": "Carpeta de datos de origen",
    "settings.language": "Idioma de la interfaz",
    "settings.languageCopy": "En el primer inicio, la interfaz sigue el idioma de su navegador. Se recuerdan las elecciones manuales.",
    "settings.notificationsCopy": "Notificar cuando las tareas se completen o fallen. Las notificaciones del sistema deben habilitarse manualmente.",
    "settings.inAppNotification": "Notificaciones dentro de la aplicación",
    "settings.systemNotification": "Notificaciones del sistema",
    "settings.save": "Guardar configuración",
    "settings.loadFailed": "No se pudo cargar la configuración",
    "settings.saveFailed": "No se pudo guardar la configuración",
    "settings.savedRestart": "Configuración de almacenamiento guardada. Reinicie WebUI para aplicar.",
    "settings.saved": "Guardado",
    "settings.savedRestartStatus": "Configuración de almacenamiento guardada. Reinicie WebUI para aplicar.",
    "systemSettings.title": "Configuración del sistema",
    "systemSettings.tabsLabel": "Secciones de configuración del sistema",
    "systemSettings.apiTab": "API Configuración",
    "systemSettings.codexTab": "Codex Canal",
    "systemSettings.languageTab": "Idioma / Language",
    "systemSettings.storageTab": "Almacenamiento y notificaciones",
    "languageSettings.instantStatus": "Los cambios de idioma se aplican inmediatamente.",
    "apiSettings.title": "API Configuración",
    "apiSettings.status": "La configuración guardada se aplica inmediatamente en el modo API",
    "apiSettings.codexMode": "Codex canal",
    "apiSettings.codexImages": "Image",
    "apiSettings.codexResponses": "Responses",
    "apiSettings.providers": "API proveedores",
    "apiSettings.searchProviders": "Buscar nombres de proveedores",
    "apiSettings.noProviderSearchResults": "No hay proveedores coincidentes",
    "apiSettings.providerCount": "{count} proveedores",
    "apiSettings.provider": "Proveedor",
    "apiSettings.providerName": "Nombre del proveedor",
    "apiSettings.actualRequest": "Solicitud real",
    "apiSettings.newProviderAction": "Nuevo proveedor",
    "apiSettings.copyProvider": "Copiar",
    "apiSettings.copyProviderName": "{name} Copiar",
    "apiSettings.copyProviderStatus": "Proveedor copiado con su clave guardada. Edite el nombre, modelo o reemplace la clave antes de guardar.",
    "apiSettings.copyProviderWithoutKeyStatus": "Proveedor copiado. Edite el nombre, modelo o agregue una clave API antes de guardar.",
    "apiSettings.sortProviders": "ordenar",
    "apiSettings.finishSortProviders": "hecho",
    "apiSettings.sortProviderModeStatus": "Clasificación de proveedores",
    "apiSettings.sortProviderStatus": "El orden del proveedor cambió. Guardando automáticamente...",
    "apiSettings.moveProviderUp": "arriba",
    "apiSettings.moveProviderDown": "abajo",
    "apiSettings.moveProviderUpAria": "Mover {provider} hacia arriba",
    "apiSettings.moveProviderDownAria": "Mover {provider} hacia abajo",
    "apiSettings.mode": "Modo de solicitud",
    "apiSettings.images": "Imagen directa API",
    "apiSettings.responses": "Responses API",
    "apiSettings.modeImagesShort": "directo",
    "apiSettings.imageModel": "Modelo de generación de imágenes",
    "apiSettings.concurrency": "Límite de simultaneidad",
    "apiSettings.concurrencyShort": "concurrencia",
    "apiSettings.advancedSettings": "Configuración avanzada",
    "apiSettings.concurrencyValue": "concurrencia {concurrency}",
    "apiSettings.keySaved": "API clave guardada",
    "apiSettings.keyNotSet": "API clave no configurada",
    "apiSettings.showApiKey": "Mostrar API Key",
    "apiSettings.hideApiKey": "Ocultar API Key",
    "apiSettings.editProvider": "Editar proveedor",
    "apiSettings.newProviderTitle": "Nuevo proveedor",
    "apiSettings.editHint": "El proveedor de guardado escribe esta edición en el backend. Cancelar lo descarta.",
    "apiSettings.finishEditFirst": "Guarde o cancele primero la edición del proveedor actual",
    "apiSettings.newDraftStatus": "Creando proveedor. Guarde el proveedor para aplicar.",
    "apiSettings.editDraftStatus": "Proveedor de edición. Guarde el proveedor para aplicar.",
    "apiSettings.cancelEdit": "Cancelar edición",
    "apiSettings.saveProvider": "Guardar proveedor",
    "apiSettings.saveSelection": "Guardar selección",
    "apiSettings.deleteProviderTitle": "¿Eliminar proveedor?",
    "apiSettings.deleteProviderMessage": "¿Eliminar \"{provider}\"?",
    "apiSettings.deleteProviderDetail": "Esto lo elimina de la lista de proveedores y lo guarda automáticamente en el backend.",
    "apiSettings.deleteProviderStatus": "Proveedor eliminado. Guardando automáticamente...",
    "apiSettings.save": "Guardar la configuración de API",
    "apiSettings.loadFailed": "No se pudo cargar la configuración API",
    "apiSettings.savedKeyPlaceholder": "La clave API se guarda en el backend. Ingrese una nueva clave para reemplazarla.",
    "apiSettings.newProvider": "Nuevo proveedor",
    "apiSettings.saving": "Guardando...",
    "apiSettings.savingStatus": "Guardando la configuración de API...",
    "apiSettings.autoSaving": "Guardando automáticamente...",
    "apiSettings.autoSaved": "Guardado automáticamente",
    "apiSettings.saveFailed": "No se pudo guardar la configuración de API",
    "apiSettings.savedSummary": "Guardado · Codex {codex} · API {provider} · {mode} · {model} · concurrencia {concurrency}",
    "apiSettings.savedShort": "Guardado",
    "apiSettings.savedStatus": "API configuración guardada",
    "apiSettings.saveFailedShort": "Error al guardar",
    "codexSettings.title": "Codex Canal",
    "codexSettings.status": "Elija el canal de generación para el inicio de sesión local Codex",
    "codexSettings.notesLabel": "Codex notas del canal",
    "codexSettings.imagesTitle": "Codex Image",
    "codexSettings.imagesCopy": "Canal predeterminado para pasar parámetros de tamaño, calidad y edición directamente.",
    "codexSettings.responsesTitle": "Codex Responses",
    "codexSettings.responsesCopy": "Canal de compatibilidad para flujos de trabajo que necesitan herramientas de búsqueda web.",
    "codexSettings.current": "Actual",
    "codexSettings.save": "Guardar canal Codex",
    "codexSettings.saveMode": "Guardar {mode}",
    "imageEditor.title": "Editar imagen de entrada",
    "imageEditor.promptHint": "Las flechas y marcas dibujadas a mano en la imagen son solo instrucciones. No los guardes en la imagen final.",
    "imageEditor.inputFallback": "Imagen de entrada",
    "imageEditor.openFailed": "No se pudo abrir esta imagen para editarla",
    "imageEditor.loadForEditFailed": "No se pudo cargar esta imagen para editarla",
    "imageEditor.canvasCreateFailed": "No se pudo crear el lienzo de edición de imágenes",
    "imageEditor.closedRegionRequired": "Utilice el pincel para dibujar primero una región cerrada",
    "imageEditor.saveFailed": "No se pudo guardar la edición de la imagen",
    "imageEditor.saved": "Imagen de entrada editada guardada",
    "imageEditor.uneditable": "Esta imagen no se puede editar",
    "imageEditor.resetDone": "Restablecer a la imagen original",
    "imageEditor.resetFailed": "No se pudo restablecer la imagen original",
    "imageEditor.subtitle": "Recorta, dibuja, rellena o agrega flechas y luego guárdalo como una nueva imagen de entrada",
    "imageEditor.toolbar": "Barra de herramientas del editor de imágenes",
    "imageEditor.tools": "Herramientas",
    "imageEditor.select": "Seleccionar",
    "imageEditor.brush": "cepillo",
    "imageEditor.arrow": "Flecha",
    "imageEditor.crop": "Cultivo",
    "imageEditor.fill": "Rellenar",
    "imageEditor.fillLabel": "Llenado del cubo de pintura",
    "imageEditor.eraser": "Borrador",
    "imageEditor.colors": "Colores",
    "imageEditor.red": "rojo",
    "imageEditor.blue": "azul",
    "imageEditor.green": "verde",
    "imageEditor.yellow": "amarillo",
    "imageEditor.white": "blanco",
    "imageEditor.black": "negro",
    "imageEditor.customColor": "Color personalizado",
    "imageEditor.stroke": "Accidente cerebrovascular",
    "imageEditor.history": "Historia",
    "imageEditor.undo": "Deshacer",
    "imageEditor.redo": "Rehacer",
    "imageEditor.reset": "Restablecer imagen",
    "imageEditor.canvas": "Lienzo de edición de imágenes",
    "imageEditor.canvasScope": "Rango del lienzo",
    "imageEditor.canvasScopeBase": "Imagen base",
    "imageEditor.canvasScopeFit": "Ajustar a capas",
    "imageEditor.canvasFitDone": "Lienzo ajustado al rango de capas",
    "imageEditor.canvasBaseDone": "Lienzo restaurado al rango de la imagen base",
    "imageEditor.insertImages": "Insertar imágenes",
    "imageEditor.layers": "Capas",
    "imageEditor.layerUp": "Subir",
    "imageEditor.layerDown": "Bajar",
    "imageEditor.emptyInsertList": "No hay otras imágenes de entrada",
    "imageEditor.selectLayerFirst": "Selecciona primero una capa",
    "imageEditor.baseLayer": "Imagen base",
    "gallery.title": "Galería",
    "gallery.subtitle": "Elija imágenes de referencia para la tarea actual",
    "gallery.manageCategories": "Administrar categorías",
    "gallery.categoryManager": "Administrar categorías de galería",
    "gallery.categoryManagement": "Gestión de categorías",
    "gallery.categoryCopy": "Las categorías se guardan en la galería; Los roles de aviso describen cómo se utilizan las referencias.",
    "gallery.newCategoryName": "Nuevo nombre de categoría",
    "gallery.newCategoryRole": "Función inmediata, p. referencia de estilo",
    "gallery.addCategory": "Añadir categoría",
    "gallery.drawerSubtitle": "Categoría actual: {category}. Haga clic en \"Usar\" para agregarlo a la entrada de imagen.",
    "gallery.emptyCategory": "Aún no hay imágenes en esta categoría",
    "gallery.dragSort": "Arrastra para ordenar",
    "gallery.dragSortImage": "Arrastrar y ordenar imagen {name}",
    "gallery.dragSortCategory": "Categoría de clasificación por arrastre {name}",
    "gallery.use": "uso",
    "gallery.replace": "Reemplazar",
    "gallery.rename": "Cambiar nombre",
    "gallery.moveCategory": "Categoría",
    "gallery.note": "Nota",
    "gallery.delete": "Eliminar",
    "gallery.uncategorized": "Sin categoría",
    "addGallery.title": "Agregar a la galería",
    "addGallery.copy": "Los nombres son únicos globalmente y se puede hacer referencia a ellos con @name más adelante.",
    "addGallery.name": "Nombre",
    "addGallery.namePlaceholder": "Ejemplo: Mía",
    "addGallery.category": "Categoría",
    "addGallery.note": "Nota de referencia",
    "addGallery.notePlaceholder": "Ejemplo: referencia únicamente a la cara y el cabello, no a la ropa ni al fondo.",
    "addGallery.save": "Guardar en la galería",
    "close.promptTemplates": "Cerrar panel de plantillas de mensajes",
    "close.archive": "Cerrar panel de archivo",
    "close.settings": "Cerrar el panel de configuración de almacenamiento",
    "close.apiSettings": "Cerrar el panel de configuración API",
    "close.systemSettings": "Cerrar el panel de configuración del sistema",
    "close.imageEditor": "Cerrar el panel del editor de imágenes",
    "close.gallery": "Cerrar panel de galería",
    "close.addGallery": "Cerrar agregar al panel de la galería",
    "close.version": "Cerrar panel de actualización de versión",
    "imageInput.referenceTitle": "Entrada de referencia (opcional)",
    "referenceFiles.add": "Añadir archivo",
    "referenceFiles.selected": "Archivos de referencia",
    "referenceFiles.recent": "Archivos recientes",
    "referenceFiles.familyPdf": "Páginas + texto",
    "referenceFiles.familySpreadsheet": "Hoja de cálculo",
    "referenceFiles.familyDocument": "Documento",
    "referenceFiles.familyText": "Texto",
    "referenceFiles.visualLimit": "Los archivos que no sean PDF no conservan imágenes ni gráficos incrustados. Convierte a PDF si importa el diseño.",
    "referenceFiles.remove": "Quitar {filename}",
    "referenceFiles.switchTitle": "¿Quitar archivos de referencia?",
    "referenceFiles.switchMessage": "Los archivos de referencia solo funcionan con Responses. Quítalos antes de cambiar a Images.",
    "referenceFiles.removeAndSwitch": "Quitar archivos y cambiar",
    "referenceFiles.requiresResponses": "Los archivos de referencia requieren Responses",
    "referenceFiles.switchToResponses": "Cambiar a Responses",
    "referenceFiles.openApiSettings": "Abrir ajustes de API",
    "referenceFiles.providerMissing": "El proveedor de Responses original no está disponible. Elige uno en los ajustes de API.",
    "referenceFiles.missing": "Falta el archivo",
    "referenceFiles.loadFailed": "No se pudieron cargar los archivos de referencia",
    "referenceFiles.errorEmpty": "El archivo de referencia está vacío",
    "referenceFiles.errorUnsupported": "Este tipo de archivo de referencia no es compatible",
    "referenceFiles.errorMismatch": "El contenido no coincide con la extensión",
    "referenceFiles.errorInvalid": "El archivo de referencia no es válido",
    "referenceFiles.errorTooLarge": "Cada archivo de referencia debe ocupar menos de 50 MB",
    "referenceFiles.errorTotalTooLarge": "Los archivos de referencia no pueden superar 50 MB en total",
    "referenceFiles.errorMissing": "Falta un archivo de referencia seleccionado",
    "referenceFiles.errorProviderUnsupported": "Responses de este proveedor no admite archivos de referencia",
    "referenceFiles.responsesEnabled": "Responses activado",
    "referenceFiles.historyPathMismatch": "Estos archivos usan rutas de Responses distintas",
    "history.referenceFiles": "Archivos de referencia",
    "history.downloadReferenceFile": "Descargar archivo",
    "history.readdReferenceFile": "Añadir de nuevo",
};
